import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import global_en from "./lang/en.json";
import global_es from "./lang/es.json";
import global_fr from "./lang/fr.json";

import { AG_GRID_EN } from "./lang-ag/en";
import { AG_GRID_ES } from "./lang-ag/es";
import { AG_GRID_FR } from "./lang-ag/fr";


const getLang = localStorage.getItem("lang"); // get lang from localStorage

const resources = {
  // call here global lang only
  en: {
    translation: global_en
  },
  es: {
    translation: global_es
  },
  fr: {
    translation: global_fr
  }
};

i18n
  .use(initReactI18next) 
  .init({
    resources,
    fallbackLng: 'en', // by default, if not set, it will be en
    lng: getLang,  // from localStorage or default to en
    debug: false, // to debug
    interpolation: {
      escapeValue: false
    }
  });

  const agGridTrans = {
    // call here AG Grid lang only
    en: AG_GRID_EN,
    es: AG_GRID_ES,
    fr: AG_GRID_FR,
  };


  export {i18n, agGridTrans};